import type { GoodsData } from '@banhala/ui-kit';
import type { MarketHomeGoodsItem } from 'shared/src/api';
import { convertRenderDataToGoodsData } from 'shared/src/utils/convertRenderDataToGoodsData';

export const convertMarketHomeGoodsItemToGoodsData = (
  input: MarketHomeGoodsItem,
): GoodsData & MarketHomeGoodsItem => {
  return {
    ...input,
    ...convertRenderDataToGoodsData(input, {
      topNudgingStrategy: 'separate-fields',
    }),
  };
};
